import { Field } from '../shared/model/field.model';

export const compareByOrderNo = (a: Field<string>, b: Field<string>): number => (a?.orderNo ?? 0) - (b?.orderNo ?? 0);
